import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import { Card, CardHeader, CardContent, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";

import organizations from "config/organizations";

import MapButton from "./MapButton";

const OrganizationLayout = props => {
  const columnSizes = (noOrganizations, min) =>
    Math.max(12 / noOrganizations, min);
  return (
    <Row>
      <Col xs={12}>
        <Card>
          <CardHeader
            title="Select a organization"
            style={{ textAlign: "center" }}
          />
          <CardContent>
            <Row
              style={{
                display: "flex",
                gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))"
              }}
            >
              {props.allowedOrganizations &&
              props.allowedOrganizations.length ? (
                organizations
                  .filter(organization =>
                    props.allowedOrganizations.includes(
                      organization.name.toUpperCase()
                    )
                  )
                  .map(organization => {
                    return (
                      <Col
                        style={{
                          boxShadow: "rgba(0, 0, 0, 0.56) 0px 22px 70px 4px",
                          minWidth: "320px",
                          flexBasis: "15%",
                          height: "auto",
                          borderRadius: "15%",
                          width: "100%",
                          margin: " 30px 45px",
                          hover: { border: "1px" }
                        }}
                        key={organization.name}
                        xs={columnSizes(props.allowedOrganizations.length, 12)}
                        md={columnSizes(props.allowedOrganizations.length, 6)}
                        lg={columnSizes(props.allowedOrganizations.length, 4)}
                        xl={columnSizes(props.allowedOrganizations.length, 3)}
                      >
                        <MapButton
                          onClick={() =>
                            props.onSelectOrganization(organization.name)
                          }
                          label={organization.label}
                          img={organization.img}
                        />
                      </Col>
                    );
                  })
              ) : (
                <Typography style={{ textAlign: "center", margin: "5px" }}>
                  <WarningIcon />
                  <b>
                    You need access to organizations to be able to use this
                    page. Please contact eims.support@hakai.org to request
                    access.
                  </b>
                </Typography>
              )}
            </Row>
          </CardContent>
        </Card>
      </Col>
    </Row>
  );
};

OrganizationLayout.propTypes = {
  onSelectOrganization: PropTypes.func.isRequired,
  allowedOrganizations: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default OrganizationLayout;
